const React = require("react");
const PropTypes = require("prop-types");

const CardList = require("@cow/core-components/components/CardListV2");
const {getPaymentMethodUITypeIcon} = require("../../utils/icons");

const {useMemo} = React;

const PaymentMethodInfoV2 = (
  {
    paymentMethod,
    siteId,
    rebrandingMP,
    bottomContent
  }) => {

  const method = useMemo(() => getPaymentMethodUITypeIcon({
      siteId,
      id: paymentMethod?.id,
      type: paymentMethod?.type,
      method: paymentMethod?.method,
      issuerName: paymentMethod?.issuer_name,
      rebrandingMP,
    }), [siteId, paymentMethod, rebrandingMP]);

  const cardListProps = useMemo(() => ({
    withChevron: false,
    withDivider: false,
    items: [
      {
        id: paymentMethod?.id,
        method,
        description: paymentMethod?.detail,
        title: paymentMethod?.title,
      },
    ],
  }), [paymentMethod, method]);

  return (
    <div className="content-payment-method-info">
      <CardList
        className="payment-method-info"
        {...cardListProps}
        bottomContentList={bottomContent}
      />
    </div>
  )

}

PaymentMethodInfoV2.propTypes = {
  paymentMethod: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    method: PropTypes.string,
    issuer_name: PropTypes.string,
    detail: PropTypes.string,
    title: PropTypes.string,
  }),
  siteId: PropTypes.string.isRequired,
  rebrandingMP: PropTypes.bool,
  bottomContent: PropTypes.node,
};

module.exports = PaymentMethodInfoV2;
